import React, { useState, useEffect, useRef } from 'react';

import ScatterPlotComponent from './Component';

const MIN_SCATTER_PLOT_HEIGHT = 500;

const ScatterPlotContainer = props => {
  const [height, setHeight] = useState();
  const [width, setWidth] = useState();
  const containerRef = useRef(null);

  useEffect(() => {
    setWidth(containerRef.current.clientWidth);

    setHeight(Math.max(
      containerRef.current.clientHeight,
      MIN_SCATTER_PLOT_HEIGHT
    ));
  }, [containerRef]);

  return (
    <div ref={containerRef} className="flex flex-grow">
      {
        containerRef.current &&
        <ScatterPlotComponent
          {...props}
          width={width}
          height={height}
        />
      }
    </div>
  );
};


export default ScatterPlotContainer;
